import { HiOutlineExternalLink } from 'react-icons/hi';

/**
 * Returns the Project Log row component.
 *
 * @param {*} param0
 * @returns The Project Log row component.
 */
const ProjectLogRow = ({ projectLog, users, formatUNIX }) => {
  function getUsersName() {
    if (!users || !Array.isArray(users)) return projectLog.userID || 'Unknown';

    const user = users.find((u) => u && u.Username === projectLog.userID);
    if (!user) return projectLog.userID || 'Unknown';

    const attrs = Array.isArray(user.Attributes) ? user.Attributes : [];
    const given = attrs.find((a) => a && a.Name === 'given_name')?.Value || '';
    const family = attrs.find((a) => a && a.Name === 'family_name')?.Value || '';

    const name = `${given} ${family}`.trim();
    return name || (user.Username || projectLog.userID || 'Unknown');
  }

  /**
   * Returns a string representation of the type of log (Edit, Delete, etc).
   *
   * @returns The correct action.
   */
  function getAction() {
    if (projectLog.category === "update") {
      return "Edit";
    } else if (projectLog.category === "delete") {
      return "Delete";
    } else if (projectLog.category === "permaDelete") {
      return "Permanently Deleted";
    } else if (projectLog.category === "restore") {
      return "Restore";
    } else if (projectLog.category === "visualizationApproval") {
      return projectLog.status === "approved" ? "Visualization Approved" : "Visualization Declined";
    } else if (projectLog.category === "rejected") {
      return "Rejected";
    }
  }
  
  /**
   * Returns the correct data-cy attribute to be used in end-to-end testing
   * @returns The data-cy attribute
   */
  function getDataCy(){
    if (projectLog.category === "update") {
      return "Comparison Link";
    } else if (projectLog.category === "delete") {
      return "Delete Link";
    } else if (projectLog.category === "permaDelete") {
      return "PermaDelete Link";
    } else if (projectLog.category === "restore") {
      return "Restore Link";
    } else if (projectLog.category === "visualizationApproval") {
      return "Visualization Link";
    } else if (projectLog.category === "rejected") {
      return "Rejected Link";
    }
  }
  const isDeleteAction = projectLog.category === "permaDelete";
  return (
    <>
      <tr className="py-12" key={projectLog.id}>
        <td className="max-w-0 py-4 pl-6 pr-3 text-sm sm:text-base font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
          <div className='flex items-center'>
            {!isDeleteAction ? (
              // Link will be displayed for non-delete actions
              <>
                <a
                  className='hover:underline cursor-pointer whitespace-normal break-all text-black'
                  data-cy={getDataCy()}
                  href={projectLog.category === "update" ? `/admin/edit-comparison?id=${projectLog.id}&date=${projectLog.Date}` : `/metadata-display/${projectLog.projectID}`}
                >
                  {projectLog.projectTitle}
                </a>
                <div className='pl-1.5'>
                  <HiOutlineExternalLink />
                </div>
              </>
            ) : (
              // Just the title text for delete actions because I think the project is deleted there's no need to provide link
              <span className='whitespace-normal break-all text-black'>
                {projectLog.projectTitle}
              </span>
            )}
          </div>

          <dl className="font-normal lg:hidden">
            <dt className="sr-only sm:hidden">User</dt>
            <dd className="mt-1 truncate text-gray-500 sm:hidden">{getUsersName()}</dd>
          </dl>
        </td>
        

        <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">
          {getUsersName()}
        </td>

        <td className="px-3 py-4 text-sm sm:text-base text-gray-500">{formatUNIX(projectLog.Date)}</td>

        <td className="px-3 py-4 text-sm sm:text-base text-gray-500">{getAction()}</td>
      </tr>
    </>
  );
};

export default ProjectLogRow;
